import xs from "xstream"
import delay from "xstream/extra/delay"
import isolate from "@cycle/isolate"
import * as R from "ramda"

import {PAGE, STATE_KEY, API, INPUT_CHECK, IDOU_KUBUNS} from '../../constant'
import {CheckResult} from '../../interface'

import {pageViewTempl, input2Prop, createApiReq, createApiResp, apiOK, apiNG, createApiReqEx, createInputCheck} from '../common'
import {fmtMember} from "../common"

import {view} from './view'

const loginReq = createApiReq('login')
const loginResp = createApiResp('login')

const loginCheck = createInputCheck(INPUT_CHECK['loginId'])
const passwordCheck = createInputCheck(INPUT_CHECK['password'])

const initReq = createApiReqEx('init')
const initResp = createApiResp('init')

// FOR TEMPORARY TREATMENT UNTIL POINT LOG PDF DOWNLOADER IS READY ON NEWER API
const oldLoginReq = createApiReq('oldLogin')
const oldLoginResp = createApiResp('oldLogin')

const memberOK = (resp: any) => {
	const kubun = parseInt(R.path(["data", "user", "occupation"], resp), 10)
	return kubun === 0 || kubun === 1
}
const Login = sources => {
	const loginInput$ = sources.DOM.select("#loginId").events('input').map(input2Prop('loginId'))
	const passwordInput$ = sources.DOM.select("#password").events('input').map(input2Prop('password'))
	const btnLogin$ =  sources.DOM.select("#btnLogin").events('click').mapTo('/policy')
	const topText$ = sources.state.select([STATE_KEY.TopText])

	/* SAVED ID */
	const savedId$ = sources.localConfig.select("userId")
		.map(R.propOr("", "value"))
		.map((loginId: string) => ({loginId}))

	const savedIdReq$ = xs.of({command: 0, key: "userId"})
	/* USER INPUT */
	const initLoginForm$ = sources.state
		.select([STATE_KEY.LoginForm])
		// .map(m => m.toJS())

	const loginForm$ = xs.merge(initLoginForm$, loginInput$, passwordInput$, savedId$)
		.fold((acc, cur) => {
			return Object.assign(acc, cur)
		}, {})

	/* AUTH COMM */
	const loginReq$ = btnLogin$
		.mapTo(
      loginForm$.map(loginReq).take(1)
		)
		.flatten()
	const loginResp$ = loginResp(sources.HTTP)

	/* INPUT ERROR HANDLING */
	const parseMessage = (chk:CheckResult) => chk.check ? null : chk.message
	const loginCheck$ = loginCheck(loginInput$).map(parseMessage)
	const passwordCheck$ = passwordCheck(passwordInput$).map(parseMessage)


  const userState$ = loginResp$
    .filter(apiOK)
    .map(R.prop("data"))
    .map((resp: any) => {
      const { user } = resp
      const { lastName, firstName, lastNameYomi, firstNameYomi, jua, jsog, lastNameEng, firstNameEng, middleNameEng } = user
      return R.mergeLeft(
        R.mergeLeft({ baseForm: {lastName, firstName, lastNameYomi, firstNameYomi, jua, jsog, lastNameEng, firstNameEng, middleNameEng } }, resp)
      )
    })

	/* INIT REQUEST */
	const initReq$ = loginResp$
		.filter(apiOK)
		.filter(memberOK)
		.map(R.path(["data", "user", "id"]))
		.map((id: string) => initReq({
			url: API["init"](fmtMember(id)),
			method: "GET",
		}))

	const initResp$ = initResp(sources.HTTP)
	
	const initState$ = initResp$
    .filter(apiOK)
    .map(R.prop("data"))
    .map((resp: any) => R.mergeLeft(resp))

	const userKubunMsg$ = loginResp$
		.filter(apiOK)
		.filter(R.compose(R.not, memberOK))
		.map(R.path(["data", "user", "occupation"]))
		.map((kubun: string) => {
			const kubunDesc = R.nth(parseInt(kubun), IDOU_KUBUNS)
			return `会員区分が「${kubunDesc}」となっています。事務局にご連絡ください。`
		})

	const oldLoginReq$ = initState$
		.mapTo(loginForm$.map(R.assoc("orgId", 1)).map(oldLoginReq).take(1))
		.flatten()
	const oldLoginResp$ = oldLoginResp(sources.HTTP)


	const loginMsg$ = xs.merge(loginResp$, initResp$)
		.filter(apiNG)
		.map(({ message }: any) => message)

	const isBusy$ = xs.merge(loginReq$.mapTo(true), loginMsg$.mapTo(false), initState$.mapTo(false), userKubunMsg$.mapTo(false)).startWith(false)

	const forgotRoute$ = sources.DOM.select(".link").events("click").mapTo("/forgot")

	// const route$ = initState$.mapTo("/policy").compose(delay(100))
	const route$ = oldLoginResp$.mapTo("/policy").compose(delay(100))

	const saveId$ = loginResp$
		.filter(apiOK)
		.map(R.path(["data", "user", "id"]))
		.map((id: number) => {
			const key = "userId"
			const value = fmtMember(id)
			return {
				command: 1,
				key,
				value: {key, value},
			}
		})


	const errMsg$ = xs.merge(loginMsg$, loginCheck$, passwordCheck$, loginReq$.mapTo(null), userKubunMsg$).startWith(null)
	const view$ = view(loginForm$, topText$, errMsg$, isBusy$) 
	const pageView = pageViewTempl(PAGE.Login.id)

	return {
		DOM: pageView(view$),
		router: xs.merge(route$, forgotRoute$),
		HTTP: xs.merge(loginReq$, initReq$, oldLoginReq$),
		state: xs.merge(userState$, initState$),
		loading: isBusy$,
		localConfig: xs.merge(savedIdReq$, saveId$),
  }
}
export default isolate(Login)
